import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            漫画分类
          </h2>
          <p className="text-sm text-foreground-500 mt-2">按喜好探索，总有一个类型适合你</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-6 md:p-8 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-all duration-300"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300 mb-4">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 mb-1">{cat.name}</h3>
              <p className="text-xs text-foreground-500 text-center">{cat.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}